export function hardNavigate(path: string) {
    window.location.assign(path)
}
